import { useContext } from 'react';
import { AuthContext } from '../auth-provider/AuthContext';

// eslint-disable-next-line react-hooks/rules-of-hooks
export const useAuth = () => useContext(AuthContext);
